var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-number-input"},[_c('span',{staticClass:"btn-subtract",on:{"click":_vm.subtract}},[_vm._v("-")]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"btn-plus",on:{"click":_vm.add}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }